{
  "en": {
    "appModal": {
      "messages": {
        "confirm": {
          "dirty": "You have unsaved changes that will be lost."
        }
      }
    }
  }
}
